import { render, staticRenderFns } from "./ModalReferralGuide.vue?vue&type=template&id=a915e6b6&"
import script from "./ModalReferralGuide.vue?vue&type=script&lang=js&"
export * from "./ModalReferralGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports